/**
 * OPS'S WORDS BESIDE A TICK OR A BUTTON THAT SAVES A WAY TO PAY, AND THE WORDS OPS HOLDS, drawn as
 * ops prints them: the paragraph beside her tick on the bank and the card screens (`StripeWay.tsx`),
 * the paragraph beside "Save a bank account" and "Save a card" on How you pay (`SaveMethod.tsx`,
 * round five, slice A5, ops's section 12.5), and, since round six's slice S4, the words ops holds
 * for her automatic payment (12.1, `terms_words`) on Your agreement and How you pay, and the written
 * scope of work an agreement pins. Each of ops's paragraphs ends with the ways to stop, the office's
 * number among them.
 *
 * - NOT A CHARACTER CHANGES (`HeldWords`): the words are ops's, read exactly as ops sent them, their
 *   spaces and line breaks among them. Words that do not name the number are drawn as they are.
 * - THE OFFICE'S NUMBER IS A LINK TO CALL IT, whole on its line, each time the words name it; what
 *   follows it with no space, the comma section 12.5's ending puts there, stays with it on its line
 *   in the span that does not wrap, as `Phone.tsx` keeps a full stop (round five, slice A4), and the
 *   space before it stays outside, so the line still breaks there. The number she is told to call or
 *   text to stop the charges never breaks in two at its hyphen, as it did in the held words on a
 *   phone (the replay of 2026-10-18).
 * - THE ADDRESS SHE IS TOLD TO EMAIL STAYS ITS WORDS, after the number: it ends up on the line under
 *   the number as often as not, and a link there, its box 48 tall, would reach over the number's and
 *   take the taps on the lower half of it (the skeptic's finding on slice V3).
 * - `contract-words.test.ts` holds the number to being in each paragraph beside a tick once, and
 *   each paragraph to ops's words; `Terms.test.tsx` holds what is drawn.
 */
import { Fragment } from 'react';
import { PHONE_HREF, PHONE_SHOWN } from '../contact.ts';
import { INLINE_LINK } from './buttons.ts';

/**
 * Words ops holds or prints, every character as ops sent it, with the office's number a link to
 * call it each time they name it, whole on its line with what follows it with no space (`\S*`, up to
 * the next space or line break, which stay outside).
 */
export function HeldWords({ words }: { readonly words: string }) {
  const [first = '', ...afterEach] = words.split(PHONE_SHOWN);
  return (
    <>
      {first}
      {afterEach.map((after, index) => {
        const kept = /^\S*/.exec(after)?.[0] ?? '';
        return (
          <Fragment key={index}>
            <span className="whitespace-nowrap">
              <a href={PHONE_HREF} className={INLINE_LINK}>
                {PHONE_SHOWN}
              </a>
              {kept}
            </span>
            {after.slice(kept.length)}
          </Fragment>
        );
      })}
    </>
  );
}

/** Ops's paragraph, drawn with the office's number as a link to call it, whole on its line. */
export function TermsWords({
  words,
  className,
}: {
  readonly words: string;
  readonly className: string;
}) {
  return (
    <p className={className}>
      <HeldWords words={words} />
    </p>
  );
}
